import React, { Component } from 'react';
import styled from 'styled-components';
import {
  FormCard, FormTextInput, Container, Grid, Alert,
} from 'tabler-react';
import { router } from '../routes';
import { AuthFunctions, IsLoggedIn } from './Auth';


const P = styled.p`
  max-width: 20rem;
`;

class RegisterForm extends Component {
  state = { email: '', error: null };

  onChange = fieldname => ({ target: { value } }) => {
    this.setState({ [fieldname]: value });
  }

  componentDidMount() {
    if (this.props.loggedIn) router.navigate({ name: 'Home' });
  }

  onRequestReset = async (e) => {
    e.preventDefault();
    const { email } = this.state;
    try {
      await this.props.onRequestReset({ email });
      router.navigate({ name: 'Home' });
    } catch (e) {
      this.setState({ error: e.message.replace('GraphQL error: ', '') });
    }
  }

  render() {
    return (
      <Container>
        <Grid.Row>
          <Grid.Col className="mx-auto mt-6 col-login">
            <FormCard onSubmit={this.onRequestReset} title="Request Password Reset" buttonText="Request Reset">
              <P>Enter your email to request a password reset</P>
              { this.state.error && <Alert type="danger">{this.state.error}</Alert> }
              <FormTextInput
                onChange={this.onChange('email')}
                label="Email"
                placeholder="Email"
                name="email"
              />
            </FormCard>
          </Grid.Col>
        </Grid.Row>
      </Container>
    );
  }
}

export default () => (
  <IsLoggedIn>
    {isLoggedIn => (
      <AuthFunctions>
        {({ resetPassword }) => (
          <RegisterForm loggedIn={isLoggedIn} onRequestReset={resetPassword} />
        )}
      </AuthFunctions>
    )}
  </IsLoggedIn>
);



// WEBPACK FOOTER //
// ./src/auth/RequestPasswordReset.js